<script>
    import CompanyBasic from '../../../common/CompanyTemplate/CompanyBasic'
    import CompanyIntro from '../../../common/CompanyTemplate/CompanyIntro'
    import CompanyVideo from '../../../common/CompanyTemplate/CompanyVideo'
    import CompanyOpportunities from '../../../common/CompanyTemplate/CompanyOpportunities'

    export default {
        components: {
            CompanyBasic,
            CompanyIntro,
            CompanyVideo,
            CompanyOpportunities
        },      
        async created () {   
          this.companyID = this.$route.params.companyID
          var company = await this.$store.getters.getCompany(this.companyID)
          this.company = company.val()
          this.company.id = this.companyID
        },
        data() {
            return {
                foo: "bar",
                companyID: "",
                company: {}
            }
        },
        methods: {      
          save() {
            console.log("no saving from here")
          }
        }
        
    }
</script>

<template lang="pug">
#company-info
  #company-container.row( v-if="company.id")
    .col.s12.m12.l6
      company-basic( :company="company" :editable="false") 
      company-intro( :company="company" :editable="false")
    .col.s12.m12.l6
      company-video( :company="company" :editable="false")
      company-opportunities( :company="company" :editable="false") 
    .col.s12.m12.l12
      p &nbsp;

</template>

<style lang="sass">

#company-container.row
  padding-left: 20px;
  padding-right: 20px;

@media screen and (min-width: 1500px)
  #company-container.row
    padding-left: 100px;
    padding-right: 100px; 

.form-label
   margin: 0 !important;


.input-div
    padding: 0 .5em 0 .5em !important;
    margin: 8px !important;
    border: 2px solid #000 !important;


// modal styles
.modal-overlay2
  display: block;
  z-index: 4000;
  height: 100vh;
  width: 100vw;
  background-color: rgba(1,1,1,.5);
  top: 0px
  left: 0px
  position: fixed

.modal-content
  background-color: white
  width: 80%
  margin: 0 auto
  top: 10%
  position: relative
  padding: 10px
  height: 80vh
  overflow: auto

button 
  cursor:pointer

.close-btn 
  border: 1px solid #000;
  color: #000;
  padding: .75em 4em .75em 4em;


.close-btn-div 
  margin: 0 0 .75em 0;
  text-align: center;

.close-btn:hover 
  border-color: #33404f;
  background-color: #33404f;
  color: #fff;



// .opp-details 
//   font-size: 14px;


// /*****************************************/
// //company info block
// /*****************************************/
#notEnoughInfo 
  margin-top: 2em;
  background-color: firebrick;
  h5 
    color: white !important;



.info-container, .curr-container 
  padding: 0 1em 0 1em;

/* bmr: cancel some heinous thing materialize is doing */
.col .row 
  margin: auto
  



// #no-company-info 
//   margin: 0;


// #no-picture 
//   background-color: #f1f1f1;
//   margin: 0;
//   text-align: center;


// #no-picture .edit-div 
//   margin-top: -40px;
//   text-align: center;


// .input-field 
//   margin-top: 0 !important;


// #img-edit-icon 
//   margin-left: 40%;


// #no-picture 
//   background-color: #D3D3D3;
//   height: 200px;


// #profile-text 
//   font-size: 10px;


// .no-padding 
//     padding: 0;



// #no-company-info span 
//   font-size: 12px;
//   color: #bbbbbb;


// .edit-curr-img:hover 
//   cursor: pointer;
//   cursor: hand;


// #company-info .edit-icon 
//     margin-left: 15px !important;


// // #company-info .col 
// //   padding: 0 !important;



// .close-btn 
//   border: 1px solid #000;
//   color: #000;
//   padding: .75em 4em .75em 4em;


// .close-btn-div 
//   margin: 0 0 .75em 0;
//   text-align: center;

// .close-btn:hover 
//   border-color: #33404f;
//   background-color: #33404f;
//   color: #fff;


// .margin-top-hr 
//   margin-bottom: 0;


// #opportunities .template-row 
//   padding-bottom: 0;


// .opp-icon 
//   padding-top: .5em;
//   font-size: 32px;



// .opp.row .col 
//   padding: 0;

// /*****************************************/
// //icon css
// /*****************************************/
// #img-edit-icon 
//   margin: 0;
//   width: 50px;
//   height: 50px;




// .add-icon 
//   margin:  10px 0 0 0;
//   width: 30px;
//   height: 30px;
//   padding-right: 10px;


// .edit-icon:hover, .add-icon:hover 
//   cursor: hand;











// /*****************************************/

// .modal-footer 
//   text-align: left !important;



// .img_educ 
//   padding-top: 5em;
//   width: 80%;


// #left-col 
//   padding: 0 5em 0 0;


// #right-col 
//   padding: 0 0 0 4em;


// #list 
//   padding-left: 2em;


// h5 
//   color: #33404f;


// p 
//   font-size: 12px;

// .ind_btns 
//   margin-top: 4em;
//   color: #33404f;
//   border: 2px solid #33404f;
//   padding: 1em 4em 1em 4em;
//   font-size: 18px;
//   transition: .5s;


// .ind_btns:hover 
//   background-color: #33404f;
//   color: #fff;
//   transition: .5s;


// #search-div 
//   //padding: 4em 0 0 0 ;
//   padding: 0 .75rem 0 .75rem;
//   height: 50vh;


// #search-tbl 
//   margin-top: 7px;


// .form_btns 
//   margin: 0 -3px 100px -3px  !important;
//   color: #ffa500;
//   border: 2px solid #ffa500;
//   padding: .5em 2em .5em 2em;
//   font-size: 16px;



// #center-btn 
//   border-left: none;
//   border-right: none;


// .form_btns:hover 
//   background-color: #ffa500;
//   color: #fff;



// body 
//   margin-bottom: 2em;

// #left-btn 
//   margin-left: 0 !important;


// #tbl-hdr
//   background-color: #e5e5e5;
//   border: 1px solid black;






// // ********* educ.less ************************************//
// // ********* educ.less ************************************//
// // ********* educ.less ************************************//





// #educ-info 
//   height: 85% !important;
//   max-height: 85%; //redundant?


// body 
//   background-color: #f1f1f1;




// .navContainer 
//   background-color: #fff;


// .search-icon 
//   height: 20px;
//   margin-left: -15px !important;
//   margin-right: 5px;
//   padding: 0 !important;
//   width: 20px;


// .legend-row 
//   padding-bottom: .5em;


// .template-row 
//   //padding-bottom: .75em;


// .margin-top-hr 
//   margin-top: 1.25em;


// // .student-icon 
// //   background: url('../img/Asset10.svg') center no-repeat;
// //   background-size: contain;


// // .class-icon {
// //   background: url('../img/Asset9.svg') center no-repeat;
// //   background-size: contain;
// // }

// // .facility-icon {
// //   background: url('../img/Asset8.svg') center no-repeat;
// //   background-size: contain;
// // }

// // .student-icon-null {
// //   background: url('../img/Asset13.svg') center no-repeat;
// //   background-size: contain;
// // }

// // .class-icon-null {
// //   background: url('../img/Asset12.svg') center no-repeat;
// //   background-size: contain;
// // }

// // .facility-icon-null {
// //   background: url('../img/Asset11.svg') center no-repeat;
// //   background-size: contain;
// // }

// .banner h4 
//   padding-top: 18vh;
//   font-weight: thick;
//   color: #fff;


// .img_educ 
//   padding-top: 5em;
//   //height: 185px;
//   width: 80%;


// #left-col 
//   padding: 0 4em 0 0;


// #right-col 
//   padding: 0 0 0 4em;


// #legend 
//   padding-top: 3em;
//   padding-left: 2em;


// h5 
//   color: #dc7e33;


// .educ_btns 
//   margin-top: 4em;
//   color: #dc7e33;
//   border: 2px solid #dc7e33;
//   padding: 1em 4em 1em 4em;
//   font-size: 18px;
//   transition: .5s;


// .educ_btns:hover 
//   background-color: #dc7e33;
//   color: #fff;
//   transition: .5s;


// #search-div
//   padding: 0;
//   height: 50vh;



// #search-tbl
//   margin-top: 5px;


// #display1 
//   display: none;


// .form_btns 
//   margin: 0 -1px 100px 0 !important;
//   color: #dc7e33;
//   border: 1px solid #dc7e33;
//   border-bottom: none;
//   padding: .5em 2em .5em 2em;
//   font-size: 16px;
//   transition: .5s;


// #search-hdr 
//   padding-top: .5em;


// .form_btns:hover 
//   background-color: #dc7e33;
//   color: #fff;
//   transition: .5s;
//   cursor: pointer;


// .btn-active 
//   background-color: #dc7e33;
//   color: #fff;
//   transition: .5s;


// tbody 
//   box-shadow: 0em .4em 1em lightGrey;


// .tbl-cmp 
//   margin: 0;
//   color: #0080ff;
//   font-weight: thick;


// table 
//   margin-bottom: 2em;


// #tbl-hdr 
//   background-color: #d3d3d3;
//   border-top: 1px solid;
//   border-bottom: 1px solid;


// #profile
//   margin-top: 2em;
//   padding: .5em;
//   background-color: #fff;


// #curr, #no-video
//   margin-top: 2em;
//   padding: .5em;
//   background-color: #fff;

// #info
//   margin-top: 1em;
//   padding: .5em;
//   background-color: #fff;

// .info-container, .curr-container
//   padding: 0 1em 0 1em;

// #opps
//   margin-top: 1em;
//   padding: .5em;
//   background-color: #fff;

// #introduction 
//   white-space: pre-wrap;


// .close-btn
//   border: 1px solid #000;
//   color: #000;
//   padding: .75em 4em .75em 4em;


// .close-btn:hover
//   border-color: #dc7e33;
//   background-color: #dc7e33;
//   color: #fff;

// .close-btn-div
//   //margin-top: 2em;
//   margin-bottom: 1em;
//   text-align: center;

// #educ_info_btn
//   margin-top: 2em;

// /*****************************************/
// //icon css
// /*****************************************/
.row
  margin-bottom: 0px

.edit-div .col
  height: 0;
  padding-right: 0;

.edit-icon
  position: relative;
  z-index: 1000;
  width: 12px;
  height: 12px;


.edit-icon:hover, .edit-curr-img:hover
  cursor: pointer;
  cursor: hand;


// /*****************************************/
// //personal info css
// /*****************************************/


// #img-edit-icon
//     margin: 0;
//     width: 50px;
//     height: 50px;

// #personal-info
//   padding: 0;
//   margin: 0;

// #name 
//     margin-top: 10px;
//     font-size: 20px;
//     margin-bottom: 5px;


// #gradeAffiliation
//   margin: 0 0 1em 0;
//   text-transform: capitalize;

// #no-picture
//     background-color: #f1f1f1;
//     text-align: center;
//     //margin: 10px  0 10px 10px;

// #no-picture .edit-div
//   margin-top: -40px;
//   text-align: center;

// #picture,#educ-img
//   padding: 0;

// #email, #phone
//     margin: 0;
//     font-size: 12px;

// #school
//     margin: 0;

// #city, #state
//     font-size: 12px;

// #profile-add-icon
//   padding-right: 10px;
//   margin-left: 0;
//   margin-bottom: -12px;
//   width: 35px;
//   height: 35px;



// #no-personal-info span
//   font-size: 12px;
//   color: #bbbbbb;
// /*****************************************/
// //introduction info css
// /*****************************************/

// #info h6
//   margin-top: 10px;
//   font-size: 20px;
//   margin-bottom: 10px;
//   font-weight: normal;

// #info-add-icon
//   padding-right: 10px;
//   margin-left: 0;
//   margin-bottom: -12px;
//   width: 35px;
//   height: 35px;

// #info-edit-icon
//   margin-left: 25px !important;

// #no-intro
//   padding-left: 0;

// #no-intro span
//   font-size: 12px;
//   color: #bbbbbb;
// /*****************************************/
// //current class css
// /*****************************************/

// .input-field p
//   margin-bottom: 0;

// #curr
//   padding: .5em;


// #curr h6
//   margin-top: 10px;
//   font-weight: normal;
//   font-size: 20px;
//   margin-bottom: 10px;

// #curr-add-icon
//   padding-right: 10px;
//   margin-left: 0;
//   margin-bottom: -12px;
//   width: 35px;
//   height: 35px;

// #curr-edit-icon
//   margin-left: 25px !important;

// #no-courses
//   padding-left: 0;

// #no-courses span
//   font-size: 12px;
//   color: #bbbbbb;

// #add-course-text
//   margin-left: 10px;

// #curr-courses .row
//   margin-top: .5em !important;

// .course
//   padding-left: 0 !important;

// .course p
//   font-size: 14.5px;
//   margin: 0 !important;

// #curr-courses .row
//   margin-top: 20px;
//   text-transform: capitalize;
// /*****************************************/
// //select-
// /*****************************************/

// /*****************************************/
// //css for introduction
// /*****************************************/
// .intro-text-div 
//     padding: 0 2em 0 2em;



// #educ-intro 
//   border: 1px black solid;
//   padding-left: .25em !important;


// #opps > h6
//   padding-bottom: 10px;


// .opp > p
//   margin: 0px;


// .opp:hover 
//   cursor: pointer;


// /*****************************************/
// //form validation error css
// /*****************************************/
// #educEmail-error,
// #educName-error,
// #educPhone-error,
// #educSchool-error,
// #educState-error,
// #educCity-error 
//     margin: -10px 0 10px 0 !important;
//     font-size: 12px !important;
//     color: red !important;




// /*****************************************/
// //company info
// /*****************************************/
// #company-no-picture 
//     background-color: #f1f1f1;
//     margin: 0;


// #educ-container 
//   margin-bottom: 2em !important;


// @media screen and (max-width: 600px) 
//   #right-col, #right-col
//     img
//       padding: 0;
  

// /*****************************************/
// //checkboxes
// /*****************************************/

// [type="checkbox"]:checked+label:before
//   border-right: 2px solid #ff9800;
//   border-bottom: 2px solid #ff9800;


// [type="checkbox"]:before, [type="checkbox"].filled-in+label:after
//   z-index: 0;

// .com_th 
//   width: 35%;


// .loc_th 
//   width: 35%;


// .opp_th 
//   width: 30%;



// th, td 
//   padding-left: .75em;


// .opp-title 
//   color: #1589FF;
//   font-weight: bold;



</style>